import type { JSX } from 'react'

export const PinLockIcon = (): JSX.Element => (
  <use href='#pinLockIcon' height='100%' width='100%' />
)
